<div fxLayout="column" class="p-2">
  <div class="p-2">
    <mat-card perfectScrollbar>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="pb-3">

        <button mat-stroked-button (click)="back()">
          <mat-icon color="primary" matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
          {{ 'APP.BACK' | translate}}
        </button>

       
     
       

        <span *ngIf="totalFutureEvents > 0" fxLayout="column">
          <span
            class="accent-color">{{ 'PATIENT.TOTAL-FUTURE-EVENTS' | translate: { 'total': totalFutureEvents} }}</span>
          <a matButton [routerLink]="['/future-visits', customerID]">{{ 'PATIENT.GOTO-EVENTS-LIST' | translate }}</a>
        </span>
      </div>

      <mat-card-content>
        <div>{{ 'PATIENT.MEDICAL-WARNINGS' | translate }}</div>
        <div class="medical-info-container">

          <span fxLayoutAlign="center" *ngIf="hasMedicalWarnings && !canViewPatientMedicalData">
            {{ 'PATIENT.HAS-MEDICAL-WARNINGS' | translate }}
          </span>

          <div *ngIf="canViewPatientMedicalData"> 
            <div class="medical-info" *ngFor="let info of medicalInfo">
              <p class="medical-info-paragraph" fxLayoutAlign="start start">
                <span class="medical-info-name">{{ info.Name }}</span>
                <span class="medical-info-note">{{ info.Note }}</span>
              </p>
            </div>
            <div *ngIf="medicalInfo.length === 0" fxLayoutAlign="center">{{ 'PATIENT.NO-MEDICAL-WARNINGS' | translate }}
            </div>
          </div>
        </div>



        <table class="table mt-2" *ngIf="customer">
          <tr>
            <td> <label>{{ 'PATIENT.PATIENT-NAME' | translate }}:</label></td>
            <td>{{ customer.Name}}</td>
          </tr>
          <tr>
            <td> <label>{{ 'PATIENT.ID' | translate }}:</label></td>
            <td><span *ngIf="customer.IdentityValidationType !== 3">{{ customer.Identity }}</span></td>
          </tr>
          <tr>
            <td> <label>{{ 'PATIENT.BIRTH-DATE' | translate }}:</label></td>
            <td><span *ngIf="customer.BirthDate">{{ customer.BirthDate | amDateFormat:'L'}} ({{customer.Age}})</span></td>
          </tr>
          <tr>
            <td> <label>{{ 'PATIENT.GENDER' | translate }}:</label></td>
            <td>
              <span *ngIf="customer.Gender === 1">{{ 'GENDER.MALE' | translate}}</span>
              <span *ngIf="customer.Gender === 2">{{ 'GENDER.FEMALE' | translate}}</span>
            </td>
          </tr>
          <tr>
            <td><label>{{ 'PATIENT.PHONE' | translate }}:</label></td>
            <td>{{ customer.Mobile }}</td>
          </tr>
          <tr>
            <td> <label>{{ 'PATIENT.ADDRESS' | translate }}:</label></td>
            <td>{{ customer.FullAddress }}</td>
          </tr>
          <tr>
            <td> <label>{{ 'PATIENT.EMAIL' | translate }}:</label></td>
            <td>{{ customer.Email}}</td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="icons-buttons-container">
                <span class="ic-camera" (click)="file.click()"></span>                
                <input #file type="file" style="cursor: pointer; width:0; height:0;" multiple accept="image/*" (input)="onUploadImage($event)"/>
               
                <span class="ic-upload" (click)="onCaptureDocumentClicked($event)"></span>                
                <input #fileDocument type="file" style="cursor: pointer; width:0; height:0;" multiple accept="*/*" (change)="onUploadDocument($event)"/>
               
                <span class="ic-send-or-fill-form" (click)="onSendOrFillFormClicked($event)"></span>
              </div>
            </td>
          </tr>
        </table>


        <div class="w-100" fxLayoutAlign="center">
          <button mat-raised-button color="accent" (click)="createAppt()">{{ 'PATIENT.CREATE-APPOINTMENT' | translate }}</button>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>